import { render, staticRenderFns } from "./KeywordRenderer.vue?vue&type=template&id=5ace6a5e&scoped=true&"
import script from "./KeywordRenderer.vue?vue&type=script&lang=js&"
export * from "./KeywordRenderer.vue?vue&type=script&lang=js&"
import style0 from "./KeywordRenderer.vue?vue&type=style&index=0&id=5ace6a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ace6a5e",
  null
  
)

export default component.exports